import React, { Component } from "react";
import {
  NormalButton,
  NormalCheckbox,
  NormalInput,
  NormalTable,
  NormalButtonBackend,
} from "component/common";
import {
  getCommonApi,
  commonCreateApi,
  commonUpdateApi,
} from "redux/actions/common";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { withTranslation } from "react-i18next";
import "./style.scss";
import {
  ItemSitelists,
  getControlNoApi,
  UpdateControlNo,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MdAddCircleOutline } from "react-icons/md";
import { AiOutlineMinusCircle } from "react-icons/ai";
import SimpleReactValidator from "simple-react-validator";
export class CatalogSettingClass extends Component {
  state = {
    SiteDetails: [
      {
        label: "Item Code",
      },
      {
        label: "Item Name",
      },
    ],
    catalog_list: [],
    site_list: [],
    site: "",
    isCreation: false,
    isList: false,
    isSecondList: false,
    menuCode: null,
    parentMenu: null,
    menuDesc: "",
    colorCode: "",
    sequenceNumber: null,
    isActive: true,
    childActive: true,
    getMenu: null,
    activeIndex: -1,
    display_items: [],
    filteredCatalog: {},
    edit: false,
    activeMenu: null,
    controlNo: null,
    selectedMenu: {
      parent: "",
      child1: "",
      child2: "",
    },
  };

  componentDidMount = () => {
    this.CatalogList({});
    this.controlNoList();
    this.validator = new SimpleReactValidator({
      element: (message) => (
        <span className="error-message text-danger validNo fs14">
          {message}
        </span>
      ),
      autoForceUpdate: this,
    });
  };

  controlNoList = async () => {
    let { menuCode } = this.state;
    await this.props.getControlNoApi(`${4376}`).then((list) => {
      let newMenu = `1${list.controlNo}`;
      console.log(newMenu, "newMenu");
      this.setState({
        controlNo: list.controlNo,
        menuCode: newMenu,
      });
      console.log(menuCode, "menuCode");
    });
  };
  Listofsitelist = async () => {
    this.updateState({ is_loading: true });
    await this.props.ItemSitelists().then((res) => {
      console.log(res, "res");
      let { site_list } = this.state;
      for (let key of res) {
        site_list.push({ value: key.itemsiteId, label: key.itemsiteDesc });
      }
      console.log(site_list, "siteList");
      this.setState({
        site_list,
        is_loading: false,
      });
    });
  };
  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  CatalogList = async () => {
    this.updateState({ is_loading: true });

    await this.props
      .getCommonApi(`displaycatalog/?page=1&limit=5000`)
      .then((res) => {
        console.log(res, "response");
        let { catalog_list } = this.state;
        catalog_list = res.data.dataList;
        const parentItems = catalog_list.filter((item) => item.menu_code);
        const newItems = catalog_list.filter((item) => !item.parent_code);
        console.log(newItems, "newItems");
        const childItems = catalog_list.filter((item) => item.parent_code);

        // if (newItems.length > 0) {
        //   const highestMenuCode = Math.max(
        //     ...newItems.map((item) => parseInt(item.menu_code))
        //   );
        //   menuCode = highestMenuCode + 1;
        //   console.log(menuCode, "menuCode");
        // }

        childItems.forEach((childItem) => {
          const parentItem = parentItems.find(
            (parent) => parent.menu_code === childItem.parent_code
          );
          if (parentItem) {
            if (!parentItem.children) {
              parentItem.children = [];
            }
            parentItem.children.push(childItem);
          }
        });
        catalog_list = newItems;
        console.log(parentItems, "parentItems");

        // let cookedResponse = catalog_list.map((item)=>{
        //   if(item.menu_code===)
        // })
        console.log(catalog_list, "smtpList");
        this.setState({
          catalog_list,
          is_loading: false,
        });
      });
  };
  ListOfDisplayItems = async () => {
    let { getMenu, display_items } = this.state;
    console.log(getMenu, "getMenu");
    await this.props
      .getCommonApi(`displayItems/?menucode=${getMenu}`)
      .then((list) => {
        display_items = list.data.dataList;
      });
    console.log(display_items, "displayItems");
    this.setState({ display_items, isSecondList: true });

    this.sitecontent();
  };
  // AddChildList=async()=>{
  //   await
  // }
  temp = ({ target: { value, name } }) => {
    console.log(value, name);
    let {
      menuCode,
      parentMenu,
      menuDesc,
      colorCode,
      sequenceNumber,
      isActive,
    } = this.state;
    if (name == "menuCode") {
      menuCode = +value;
      this.setState({ menuCode });
    }
    if (name == "parentMenu") {
      parentMenu = value;
      this.setState({ parentMenu });
    }
    if (name == "menuDesc") {
      menuDesc = value;
      this.setState({ menuDesc });
    }
    if (name == "colorCode") {
      colorCode = value;
      this.setState({ colorCode });
    }
    if (name == "sequenceNumber") {
      sequenceNumber = value;
      this.setState({ sequenceNumber });
    }

    if (name == "isActive") {
      isActive = value;
      this.setState({ isActive });
    }
    console.log(this.state, "stateValues");
  };
  sitecontent() {
    this.setState({
      isCreation: !this.state.isCreation,
    });
  }
  listcontent() {
    this.setState({
      isList: !this.state.isList,
    });
  }
  secondListContent() {
    this.setState({
      isSecondList: !this.state.isSecondList,
    });
  }
  CreateDisplayCatalog = async () => {
    let {
      menuCode,
      isActive,
      sequenceNumber,
      menuDesc,
      colorCode,
      parentMenu,
      controlNo,
    } = this.state;

    let newreason = {
      menu_code: menuCode,
      parent_code: parentMenu,
      menu_description: menuDesc,
      bgcolor: colorCode,
      seqnumber: sequenceNumber,
      isactive: isActive,
    };
    console.log(newreason, "newReason");
    let newControlNo = {
      controlNo: Number(controlNo) + 1,
    };
    console.log(newControlNo, "newNum");
    if (this.validator.allValid()) {
      await this.props
        .commonCreateApi(`displaycatalog/`, newreason)
        .then(async (data) => {
          this.CatalogList({});
          await this.props
            .UpdateControlNo(
              `ControlNos/update?where=%7B%22controlId%22%3A%20${4376}%7D`,
              newControlNo
            )
            .then(() => {
              this.controlNoList();
            });
        })
        .catch((e) => console.log(e));
      this.setState({
        menuCode,
        isActive: null,
        sequenceNumber: null,
        menuDesc: "",
        colorCode: "",
        parentMenu: "",
        filteredCatalog: {},
      });
    } else {
      this.validator.showMessages();
    }
  };

  UpdateDisplayCatalog = async () => {
    let {
      menuCode,
      isActive,
      sequenceNumber,
      menuDesc,
      colorCode,
      parentMenu,
      filteredCatalog,
    } = this.state;

    let newreason = {
      menu_code: menuCode,
      parent_code: parentMenu,
      menu_description: menuDesc,
      bgcolor: colorCode,
      seqnumber: sequenceNumber,
      isactive: isActive,
    };
    if (this.validator.allValid()) {
      await this.props
        .commonUpdateApi(`displaycatalog/${filteredCatalog.id}/`, newreason)
        .then(() => {
          this.CatalogList({});
        })
        .catch((e) => console.log(e));

      this.setState({
        menuCode,
        isActive: null,
        sequenceNumber: null,
        menuDesc: "",
        colorCode: "",
        parentMenu: "",
        edit: false,
        filteredCatalog: {},
      });
    } else {
      this.validator.showMessages();
    }
  };

  toggleDropdown = (index, menuCode) => {
    this.setState((prevState) => ({
      activeIndex: prevState.activeIndex === index ? -1 : index,
    }));
    if (menuCode) {
      this.handleSelectedMenu(menuCode);
    }
    console.log(index, "index");
  };
  childDropdown = (index, menuCode) => {
    this.setState((prevState) => ({
      secondIndex: prevState.secondIndex === index ? -1 : index,
    }));
    if (menuCode) {
      this.handleSelectedMenu(menuCode);
    }
    console.log(index, "Subindex");
  };
  handleSelectedMenu = (codeVal) => {
    console.log(codeVal, "codeVal");
    let { catalog_list, selectedMenu, controlNo } = this.state;
    const filteredCatalog = this.filterByMenuCode(catalog_list, codeVal);
    let { parent_code, menu_code, menu_description } = filteredCatalog;
    console.log(filteredCatalog, "filteredCatalog");
    if (parent_code === null) {
      this.setState((prevState) => ({
        selectedMenu: {
          parent: menu_description,
          child1: "",
          child2: "",
        },
      }));
    } else if (parent_code.startsWith(100)) {
      this.setState((prevState) => ({
        selectedMenu: {
          ...prevState.selectedMenu,
          child1: menu_description,
          child2: "",
        },
      }));
    } else if (parent_code.startsWith(2100)) {
      this.setState((prevState) => ({
        selectedMenu: {
          ...prevState.selectedMenu,
          child2: menu_description,
        },
      }));
    }
  };
  handleMenuCode = (menuCode, index) => {
    console.log(menuCode, "menu");
    const { catalog_list, controlNo } = this.state;
    const filteredCatalog = this.filterByMenuCode(catalog_list, menuCode);
    let { parent_code, menu_code, menu_description } = filteredCatalog;
    console.log(filteredCatalog, "filteredCatalog");
    if (parent_code === null) {
      this.setState((prevState) => ({
        menuCode: `2${controlNo}`,
        parentMenu: menu_code,
        selectedMenu: {
          parent: menu_description,
          child1: "",
          child2: "",
        },
      }));
    } else if (parent_code.startsWith(100)) {
      this.setState((prevState) => ({
        menuCode: `3${controlNo}`,
        parentMenu: menu_code,
        selectedMenu: {
          ...prevState.selectedMenu,
          child1: menu_description,
          child2: "",
        },
      }));
    } else if (parent_code.startsWith(2100)) {
      this.setState((prevState) => ({
        menuCode: `4${controlNo}`,
        parentMenu: menu_code,
        selectedMenu: {
          ...prevState.selectedMenu,
          child2: menu_description,
        },
      }));
    }
    console.log(this.state.selectedMenu, "selected");
    this.setState({ filteredCatalog, getMenu: menuCode, activeMenu: index });
  };

  filterByMenuCode = (items, menuCode) => {
    let filteredItem = null;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.menu_code === menuCode) {
        filteredItem = item;
        break;
      }
      if (item.children) {
        const child = this.filterByMenuCode(item.children, menuCode);
        if (child) {
          filteredItem = child;
          break;
        }
      }
    }
    return filteredItem;
  };

  handleParentEdit = () => {
    let {
      filteredCatalog,
      menuCode,
      isActive,
      sequenceNumber,
      menuDesc,
      colorCode,
      parentMenu,
    } = this.state;
    let newCatalog = filteredCatalog;
    let {
      bgcolor,
      menu_code,
      menu_description,
      parent_code,
      isactive,
      seqnumber,
    } = newCatalog;
    this.setState({
      menuCode: menu_code,
      isActive: isactive,
      sequenceNumber: seqnumber,
      menuDesc: menu_description,
      colorCode: bgcolor,
      parentMenu: parent_code,
      edit: true,
    });
  };
  handleNewParent = () => {
    let { controlNo } = this.state;
    this.setState({
      menuCode: `1${controlNo}`,
      isActive: null,
      sequenceNumber: null,
      menuDesc: "",
      colorCode: "",
      parentMenu: "",
      edit: false,
      getMenu: null,
      selectedMenu: {},
      activeIndex: -1,
    });
  };
  handleAdd = () => {
    let { getMenu, filteredCatalog } = this.state;
    console.log(filteredCatalog, "filter");
    if (filteredCatalog) {
      this.props.history.push({
        pathname: "/admin/backend/catalogsetting/displayitems",
        state: {
          id: getMenu,
          data: filteredCatalog,
        },
      });
    }
  };
  render() {
    let {
      SiteDetails,
      pageMeta,
      is_loading,
      isCreation,
      isList,
      catalog_list,
      menuCode,
      parentMenu,
      menuDesc,
      colorCode,
      sequenceNumber,
      edit,
      isActive,
      isSecondList,
      display_items,
      activeMenu,
      filteredCatalog,
      getMenu,
      controlNo,
      selectedMenu,
    } = this.state;
    console.log(menuCode, "controlNo");
    let { t } = this.props;

    return (
      <>
        <div className="container-fluid tax bg-white">
          <div className="row">
            <h4 className="mt-3 text-center col-12 col-sm-8 col-md-8 col-lg-8 col-xl-7  text-md-left label-head">
              {t("Display Catalog Setting")}
            </h4>
          </div>
          <div
            className="d-flex justify-content-between p-3 itemstatusgroup"
            onClick={() => this.sitecontent()}
          >
            <p>{t("Display Catalog Setting Creation")}</p>
            <div className="icons">
              {isCreation == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>

          {isCreation == true ? (
            <div className="container-fluid  mt-3">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-5 col-xl-5 col-sm-8">
                  {catalog_list.map((item, index) => {
                    const isActive = this.state.activeIndex === index;
                    const hasChildren =
                      item.children && item.children.length > 0;

                    return (
                      <div
                        className="col-md-12  col-sm-12 col-lg-12 col-xl-12"
                        key={index}
                      >
                        <div>
                          <div className=" row d-md-flex justify-content-between align-items-center">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 d-flex align-items-center">
                              {hasChildren && !isActive ? (
                                <MdAddCircleOutline
                                  onClick={() =>
                                    this.toggleDropdown(index, item.menu_code)
                                  }
                                  className="text-success"
                                />
                              ) : hasChildren && isActive ? (
                                <AiOutlineMinusCircle
                                  className="text-danger "
                                  onClick={() => this.toggleDropdown(index)}
                                />
                              ) : (
                                ""
                              )}

                              <p
                                className={` px-3 card-title cursor-pointer ${
                                  !item.children ? "ml-3 " : ""
                                } ${
                                  getMenu === item.menu_code ? "activeMenu" : ""
                                } `}
                                onClick={() =>
                                  this.handleMenuCode(item.menu_code)
                                }
                              >
                                {item.menu_description}
                              </p>
                            </div>
                          </div>
                          {isActive && (
                            <div className=" col-md-12 col-lg-12 col-sm-12 col-xl-12 mb-2">
                              {item.children &&
                                item.children.map((child, subIndex) => {
                                  const isChildActive =
                                    this.state.secondIndex === subIndex;
                                  const hasSecondChild =
                                    child.children && child.children.length > 0;
                                  return (
                                    <div
                                      key={subIndex}
                                      className="col-md-12 col-lg-12 col-sm-12 col-xl-12"
                                    >
                                      <div className="col-md-12 col-lg-12 col-xl-12 col-sm-12 d-flex  justify-content-between align-items-center">
                                        <div className="col-md-12 col-lg-6 col-sm-12 col-xl-6 d-flex align-items-center">
                                          {hasSecondChild && !isChildActive ? (
                                            <MdAddCircleOutline
                                              onClick={() =>
                                                this.childDropdown(
                                                  subIndex,
                                                  child.menu_code
                                                )
                                              }
                                              className="text-success"
                                            />
                                          ) : hasSecondChild &&
                                            isChildActive ? (
                                            <AiOutlineMinusCircle
                                              className="text-danger"
                                              onClick={() =>
                                                this.childDropdown(subIndex)
                                              }
                                            />
                                          ) : (
                                            ""
                                          )}

                                          <p
                                            className={` px-3 card-title cursor-pointer ${
                                              !child.children ? "ml-3 " : ""
                                            } ${
                                              getMenu === child.menu_code
                                                ? "activeMenu"
                                                : ""
                                            }`}
                                            onClick={() =>
                                              this.handleMenuCode(
                                                child.menu_code
                                              )
                                            }
                                          >
                                            {child.menu_description}
                                          </p>
                                        </div>
                                      </div>

                                      {isChildActive && (
                                        <div className=" col-md-12 col-lg-12 col-sm-12 col-xl-12 mb-2 ">
                                          {child.children &&
                                            child.children.map(
                                              (list, childIndex) => (
                                                <div
                                                  key={childIndex}
                                                  className="col-md-12 col-lg-12 col-xl-12 col-sm-12 d-flex justify-content-between align-items-center"
                                                >
                                                  <div className="col-md-12 col-lg-6 col-sm-12 col-xl-6 ">
                                                    <p
                                                      onClick={() =>
                                                        this.handleMenuCode(
                                                          list.menu_code
                                                        )
                                                      }
                                                      className={`px-3 card-title cursor-pointer ${
                                                        getMenu ===
                                                        list.menu_code
                                                          ? "activeMenu"
                                                          : ""
                                                      }`}
                                                    >
                                                      {list.menu_description}
                                                    </p>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 ">
                    <div className="col-xl-6 col-lg-6 col-md-8 col-sm-12 my-3">
                      <NormalButton
                        backend={true}
                        label="Load Items"
                        onClick={() => this.ListOfDisplayItems()}
                      />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-8 col-sm-12">
                      <NormalButton
                        backend={true}
                        label="Add / Delete Items"
                        onClick={this.handleAdd}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-8 col-md-6 col-lg-7 col-xl-7">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-around align-items-center">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 my-3">
                      <NormalButton
                        backend={true}
                        label="New Parent"
                        onClick={this.handleNewParent}
                      />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <NormalButton
                        backend={true}
                        label="Edit Menu"
                        onClick={this.handleParentEdit}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>
                      Selected :
                      <span className="text-danger">
                        {selectedMenu.parent}
                        {selectedMenu.child1 && `>`}
                        {selectedMenu.child1} {selectedMenu.child2 && `>`}
                        {selectedMenu.child2}
                      </span>
                    </p>
                  </div>
                  <div className="mt-3">
                    <p>{t("Menu Code ")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={menuCode}
                        name="menuCode"
                        onChange={this.temp}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("Parent Menu Code")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={parentMenu}
                        name="parentMenu"
                        disabled
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("Menu Description")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={menuDesc}
                        name="menuDesc"
                        placeholder="Enter Menu Description"
                        onChange={this.temp}
                      />
                      {this.validator.message(
                        "Menu Description",
                        menuDesc,
                        "required"
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("Color Code")}</p>
                    <div className="input-group">
                      <div className="w-75 ">
                        <NormalInput
                          value={colorCode}
                          placeholder="Enter Color Code"
                          onChange={this.temp}
                        />
                      </div>
                      <div className="w-25 text-center">
                        <input
                          type="color"
                          onChange={this.temp}
                          name="colorCode"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("Sequence Number")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={sequenceNumber}
                        name="sequenceNumber"
                        placeholder="Enter Sequence Number"
                        onChange={this.temp}
                      />
                      {this.validator.message(
                        "Sequence Number",
                        sequenceNumber,
                        "required"
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex input-group">
                      <NormalCheckbox
                        checked={isActive}
                        name="isActive"
                        onChange={this.temp}
                      />
                      <p>{t(" Is Currently Active")}</p>
                    </div>
                  </div>
                  {!edit ? (
                    <div className="mt-3 col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 p-0">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Add"}
                        onClick={() => this.CreateDisplayCatalog()}
                      />
                    </div>
                  ) : (
                    <div className="mt-3 col-12 col-sm-6 col-md-2 col-lg-2 col-xl-2  p-0">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Update"}
                        onClick={() => this.UpdateDisplayCatalog()}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {/* <div
            className="d-flex  justify-content-between p-3 itemstatusgroup mt-5"
            onClick={() => this.listcontent()}
          >
            <p>{t("Display Catalog Setting List")}</p>
            <div className="icons">
              {isList == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div> */}
          {/* {isList == true ? (
            <div className="tab-table-content">
              <div className="d-md-flex">
                <h5 className="my-3 ml-3 label-title col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6  text-center text-md-left text-lg-left p-0">
                  {t("List of SMTP Setting")}
                </h5>
              </div>
              <div className="card-catalog ">
                {catalog_list.map((item, index) => {
                  const isActive = this.state.activeIndex === index;
                  const hasChildren = item.children && item.children.length > 0;

                  return (
                  
                    <div
                      className="col-md-6 col-sm-12 col-lg-6 col-xl-6"
                      key={index}
                    >
                      <div className="card ">
                        <div
                          className="card-body row d-flex justify-content-between align-items-center"
                          onClick={() => this.toggleDropdown(index)}
                        >
                          {item.parent_code}
                          <div className="col-md-6 col-lg-6 col-sm-6 col-xl-6">
                            <p className="card-title">
                              {item.menu_description}
                            </p>
                          </div>
                         

                          <div className="col-md-6 col-lg-6 col-sm-6 col-xl-6 mt-2  text-center">
                            {hasChildren && isActive ? (
                              <AiOutlineDown />
                            ) : hasChildren && !isActive ? (
                              <AiOutlineRight />
                            ) : (
                              <NormalButton
                                backend={true}
                                label={"View"}
                                onClick={() => this.handleChange(item.link)}
                              />
                            )}
                          </div>
                        </div>
                        {isActive && (
                          <div className=" col-md-12 col-lg-12 col-sm-12 col-xl-12 mb-2">
                            {console.log(item.children, "itemChild")}
                            {item.children &&
                              item.children.map((child, subIndex) => {
                                const isChildActive =
                                  this.state.secondIndex === subIndex;
                                const hasSecondChild =
                                  child.children && child.children.length > 0;
                                return (
                                  <div
                                    onClick={() => this.childDropdown(subIndex)}
                                    className="col-md-12 col-lg-12 col-sm-12 col-xl-12"
                                  >
                                    <div className="col-md-12 col-lg-12 col-xl-12 col-sm-12 d-flex  justify-content-between align-items-center">
                                      <div className="col-md-7 col-sm-8 col-lg-6 col-xl-6">
                                        <p className="child-title">
                                          {child.menu_description}
                                        </p>
                                      </div>
                                      <div className="col-md-5 col-sm-4 col-lg-6 col-xl-6 mt-2  text-center">
                                        {hasSecondChild && isChildActive ? (
                                          <AiOutlineDown />
                                        ) : hasSecondChild && !isChildActive ? (
                                          <AiOutlineRight />
                                        ) : (
                                          <NormalButton
                                            backend={true}
                                            label={"View"}
                                            onClick={() =>
                                              this.handleChange(item.link)
                                            }
                                          />
                                        )}
                                      </div>
                                    </div>
                                    
                                    {isChildActive && (
                                      <div className=" col-md-12 col-lg-12 col-sm-12 col-xl-12 mb-2 ">
                                        {child.children &&
                                          child.children.map((list, index) => (
                                            <div className="col-md-12 col-lg-12 col-xl-12 col-sm-12 d-flex justify-content-between align-items-center">
                                              <div className="col-md-6 col-sm-8 col-lg-6 col-xl-6">
                                                <p className="child-title">
                                                  {list.menu_description}
                                                </p>
                                              </div>
                                              <div className="col-md-6 col-sm-4 col-lg-6 col-xl-6">
                                                <NormalButton
                                                  backend_child={true}
                                                  label={"View"}
                                                  onClick={() =>
                                                    this.handleChange(list.link)
                                                  }
                                                />
                                              </div>
                                            
                                            </div>
                                          ))}
                                      </div>
                                    )}
                                  </div>
                              
                                );
                              })}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            ""
          )} */}

          <div
            className="d-flex  justify-content-between p-3 itemstatusgroup mt-5"
            onClick={() => this.secondListContent()}
          >
            <p>{t("Display Catalog List Items")}</p>
            <div className="icons">
              {isSecondList == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>
          {isSecondList == true ? (
            <div className="tab-table-content">
              <div className="d-md-flex">
                <h5 className="mt-3 ml-4 label-title col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-center text-md-left text-lg-left p-0">
                  {t("List of Items ")}
                </h5>
              </div>

              <div className="py-4">
                <div className="table-container">
                  <NormalTable
                    headerDetails={SiteDetails}
                    queryHandler={this.handlePagination}
                    pageMeta={pageMeta}
                  >
                    {is_loading ? (
                      <tr>
                        <td colSpan="7">
                          <div class="d-flex mt-5 align-items-center justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : display_items.length > 0 ? (
                      display_items.map(({ item_code, item_name }, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <div className="text-left ">{item_code}</div>
                            </td>
                            <td>
                              <div className="text-left">{item_name}</div>
                            </td>
                          </tr>
                        );
                      })
                    ) : null}
                  </NormalTable>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ItemSitelists,
      getCommonApi,
      commonCreateApi,
      commonUpdateApi,
      getControlNoApi,
      UpdateControlNo,
    },
    dispatch
  );
};

export const CatalogSetting = withTranslation()(
  connect(null, mapDispatchToProps)(CatalogSettingClass)
);
